import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Badge } from "@/components/ui/badge";
import { ERP_MODULES } from "./erpShared";

export default function ModulesBeheer({ flags, reload }) {
  const [saving, setSaving] = useState("");
  const [local, setLocal] = useState(flags || {});
  useEffect(() => { setLocal(flags || {}); }, [flags]);
  const toggle = async (key, val) => {
    const next = { ...local, [key]: val };
    setLocal(next);
    setSaving(key);
    try {
      const { data } = await api.put("/erp-modules", { modules: next });
      if (data && data.modules) setLocal(data.modules);
      toast.success(`${val ? "Ingeschakeld" : "Uitgeschakeld"}`);
      await reload();
    } catch (e) { toast.error(formatApiError(e)); setLocal(flags || {}); }
    setSaving("");
  };
  const actief = ERP_MODULES.filter((m) => m.built && local[m.key]).length;
  return (
    <div className="space-y-4" data-testid="erp-modules-beheer">
      <div>
        <h2 className="text-lg font-bold text-slate-800">ERP-modules beheren <span className="text-slate-400 font-normal">({actief} actief)</span></h2>
        <p className="text-sm text-slate-500">Zet hier per module aan of uit. <b>Uit</b> = het tabblad is voor iedereen verborgen. De opgeslagen gegevens blijven altijd bewaard; aan/uit verandert alleen de zichtbaarheid. Modules werken volledig onafhankelijk — je kunt er gerust een paar aan en een paar uit laten staan.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {ERP_MODULES.map((m) => {
          const Icon = m.Icon; const enabled = !!local[m.key];
          return (
            <div key={m.key} data-testid={`erp-module-card-${m.key}`} className={`flex items-start gap-3 rounded-xl border p-4 ${enabled ? "border-blue-300 bg-blue-50/40" : "border-slate-200 bg-white"}`}>
              <span className={`mt-0.5 flex h-9 w-9 flex-none items-center justify-center rounded-lg ${enabled ? "bg-blue-600 text-white" : "bg-slate-100 text-slate-500"}`}><Icon className="h-5 w-5" /></span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap"><span className="font-semibold text-slate-800">{m.label}</span>{!m.built && <Badge className="bg-amber-100 text-amber-700">Binnenkort</Badge>}</div>
                <p className="mt-0.5 text-xs text-slate-500">{m.desc}</p>
              </div>
              <Switch data-testid={`erp-toggle-${m.key}`} checked={enabled} disabled={!m.built || saving === m.key} onCheckedChange={(v) => toggle(m.key, v)} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
